import { motion } from "framer-motion";
import Link from 'next/link';
import Image from 'next/image';
import React, { useState, useEffect } from "react";
import Head from "next/head";

const services = [
    {
        title: 'Webdesign',
        details: ['Konzeption', 'Grafik-Design', 'Content', 'Programmierung', 'Front End Entwicklung', 'User Experience', 'Responsive', 'Intranet/Extranet', 'Relaunch'],
        imgSrc: '/serviceImages/pexels-davide-baraldi-11813187.jpg',
        pageUrl: '/services/webdesign', // Update with the desired page URL for Webdesign
    },
    {
        title: 'E-Commerce',
        details: ['Konzeption', 'B2B/B2C', 'Individuelle Programmierung', 'Individuelles Design', 'Digitale Einkaufserlebnisse', 'Funktionelle Erweiterungen', 'Konfiguratoren', 'Payment & Logistik'],
        imgSrc: '/serviceImages/pexels-anete-lusina-6331230.jpg',
        pageUrl: '/services/ecommerce', // Update with the desired page URL for E-Commerce
    },
    {
        title: 'Beratung',
        details: ['Konzepte', 'Strategie', 'Conversion-Optimierung', 'Wordpress', 'Plug Ins', 'Domain & Hosting', 'Schulung & Betreuung'],
        imgSrc: '/serviceImages/pexels-alex-green-5699456.jpg',
        pageUrl: '/services/beratung', // Update with the desired page URL for Beratung
    },
    {
        title: 'SEO',
        details: ['Suchmaschinenoptimierung', 'Content Strategien', 'Onpage-Optimierung', 'Interne Verlinkungen', 'Meta Title/ Description', 'Cross media Verlinkungen', 'Social Media'],
        imgSrc: '/serviceImages/myriam-jessier-VHXiGXxwOQ4-unsplash.jpg',
        pageUrl: '/services/seo', // Update with the desired page URL for SEO
    }
];

export default function Services() {
    const [height, setHeight] = useState(0);
    const schemaMarkup = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "deinSEOExpert Services",
        "description": "Entdecken Sie meine umfangreichen SEO-Dienstleistungen, die Ihre Website auf das nächste Level heben.",
        "serviceType": "SEO-Beratung",
        "provider": {
            "@type": "Organization",
            "name": "deinSEOExpert",
            "logo": "/deinSEOExpertdeLogo.webp",
        },
        "areaServed": "Deutschland",
        "availableChannel": {
            "@type": "ServiceChannel",
            "serviceUrl": "https://www.deinseoexpert.de"
        },
    });


    useEffect(() => {
        setHeight(window.innerHeight);
    }, []);

    const variants = {
        hidden: { opacity: 0, scale: 1, filter: "grayscale(100%)" },
        visible: { opacity: 1, scale: 1, filter: "grayscale(100%)" },
        hover: { scale: 1.05, filter: "grayscale(0%)" }
    };

    return (
        <motion.div className="flex flex-col md:flex-row justify-around p-0 h-full" initial="hidden" animate="visible" style={{ height: `${height}px` }}>
            <Head>
                <title>Services | deinSEOExpert</title>
                <link rel="icon" href="/favicon.ico"/>
                <meta
                    name="description"
                    content="Entdecken Sie meine umfangreichen SEO-Dienstleistungen, die Ihre Website auf das nächste Level heben. Von On-Page-Optimierung bis Linkaufbau - Dein SEO Expert bietet alles, um Ihre Online-Präsenz zu stärken. Erfahren Sie mehr über meine Services auf dieser Seite."
                />
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaMarkup }} />
            </Head>
            {services.map((service, index) => (
                <motion.div
                    key={index}
                    className="md:w-1/2 lg:w-1/4 h-full relative overflow-hidden flex flex-col"
                    style={{ flexGrow: 1 }}
                    variants={variants}
                    initial="hidden"
                    animate="visible"
                    whileHover="hover"
                    transition={{ type: "spring", stiffness: 300 }}
                >
                <div className="absolute inset-0 z-10 flex items-center justify-center">
                        <Link href={service.pageUrl}>
                            <lang className="text-white text-lg font-bold transform hover:scale-110 motion-reduce:transform-none">{service.title}</lang>
                        </Link>
                    </div>
                    <img
                        src={service.imgSrc}
                        alt={service.title}
                        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                    />
                </motion.div>
            ))}
        </motion.div>
    );
}
